// debounce function
function limit(func, wait, debounce) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;
    let throttler = function () {
      timeout = null;
      func.apply(context, args);
    };
    if (debounce) {
      clearTimeout(timeout);
    }
    if (debounce || !timeout) timeout = setTimeout(throttler, wait);
  };
};

export function debounce(func, wait) {
  return limit(func, wait, true);
}

export function throttle(func, wait) {
  return limit(func, wait, false);
}

export function isAndroid() {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}